// extracted by mini-css-extract-plugin
module.exports = {"events":"NotificationEventItems-events-2RsXl"};